/**
 * Official certification badges (full-resolution brand assets uploaded by the user).
 */

export const OCPlatinumBadge = ({ className = "" }) => (
  <img
    src="/badge-oc-platinum.png"
    alt="Owens Corning Platinum Preferred Contractor — Experienced. Certified. Elite. Backed by Owens Corning"
    data-testid="badge-oc-platinum"
    className={`block max-h-[170px] w-auto object-contain ${className}`}
    style={{ filter: "drop-shadow(0 6px 20px rgba(0,0,0,0.45))" }}
  />
);

export const GAFNationalCircleBadge = ({ className = "" }) => (
  <img
    src="/badge-gaf-circle.png"
    alt="GAF National Circle Contractor"
    data-testid="badge-gaf-circle"
    className={`block max-h-[170px] w-auto object-contain ${className}`}
    style={{ filter: "drop-shadow(0 6px 20px rgba(0,0,0,0.45))" }}
  />
);

export const NationsLargestBadge = ({ className = "" }) => (
  <img
    src="/badge-nations-largest.png"
    alt="Owens Corning — Nation's Largest Platinum Contractor"
    data-testid="badge-nations-largest"
    className={`block max-h-[170px] w-auto object-contain ${className}`}
    style={{ filter: "drop-shadow(0 6px 20px rgba(0,0,0,0.45))" }}
  />
);
